<h1>{{ data?.title }}</h1>
<div class="msg-content" [innerHTML]="data?.description"></div>
<dialog-actions>
    <button odl-button [disabled]="timeLeft > 0" (click)="close(true)">
        {{ data?.approve }}
        <span *ngIf="timeLeft > 0"> ...{{ timeLeft }}</span>
    </button>
    <button odl-stroked-button (click)="close()">{{ data?.decline }}</button>
</dialog-actions>